import src from '/Users/huynhducduy/workspace/innosearch/innosearch-fe/interface/src/assets/images/christmas-sales-banner.png?url';

export default {
  lqip: `data:image/png;base64,UklGRpwAAABXRUJQVlA4IJAAAABwBACdASogAAgAPm0sk0WkIqGYBABABsS2AE6ZQjACeMwgL/nTx7oH+fD2wAD+/fahB6DCiWsI7AUGEh/Dv6ixp0VVtPv1///Cujy3t8Tk9D/2Xagz/aWyp/uDj96pYIupWqUuk/LI7vSu4/KWMKkLSy8+r+Wpcqx2+SED3fvym7j/LAiu1uC73B/pWA1AAAA=`,
  src,
  width: 2448,
  height: 650,
};
			